module.exports = __webpack_public_path__ + "media/customizations/everbe/back-51d7cd406b82fe9020dc85256a05346c.jpg";